import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { User } from '@app/models';

@Injectable({ providedIn: 'root' })
export class CatalogsService {
    constructor(private http: HttpClient) { }

    getStates(): Observable<any> {
        return this.http.get<any>(environment.scs_url + '/api/catalogs/states')
            .pipe(
                retry(1),
                catchError(this.errorHandle)
            )
    }

    getCountries(): Observable<any> {
        return this.http.get<any>(environment.scs_url + '/api/catalogs/countries')
            .pipe(
                retry(1),
                catchError(this.errorHandle)
            )
    }

    getAccountInformation(account_id): Observable<any> {
        return this.http.get<any>(environment.scs_url + '/api/forms/get_account_information?id=' + account_id)
            .pipe(
                retry(1),
                catchError(this.errorHandle)
            )
    }

    getMunicipalities(state_id): Observable<any> {
        return this.http.get<any>(environment.scs_url + '/api/catalogs/municipalities/' + state_id)
            .pipe(
                retry(1),
                catchError(this.errorHandle)
            )
    }


    // Error handling
    errorHandle(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
